angular.module('bmsApp.settings')
	.factory('LeavingPromptQuestionTypeSvc', function (CRUDSvc) {

		var prefix = 'api/settings/leaving-prompt/question-type/';
		function index(params) {
			return CRUDSvc.get(prefix+'index', params);
		}

		function save(params) {
			return CRUDSvc.post(prefix+'save', params);
		}

		function read(id) {
			return CRUDSvc.get(prefix+'read/' + id);
		}

		function options(id) {
			return CRUDSvc.get(prefix+'options');
		}

		return {
			index: index,
			save: save,
			read: read,
			options: options,
		};

	});
